import React from 'react';
import { getMarkerIcon } from '../../services/DeviceMarkerIcons';

interface MapMarkerIconProps {
  icon: string;
  className?: string;
}

/**
 * Renders the unselected artwork for a configured device map-marker icon.
 */
const MapMarkerIcon: React.FC<MapMarkerIconProps> = ({ icon: iconId, className }) => {
  const icon = getMarkerIcon(iconId);
  const image = icon.images.unselected;

  return (
    <img
      alt=""
      aria-hidden="true"
      className={className}
      draggable={false}
      src={image.src}
      srcSet={image.srcset}
      style={{ objectFit: 'contain' }}
    />
  );
};

export { MapMarkerIcon };
